// extracted by mini-css-extract-plugin
export default {"bg":"Background_bg__ZxFDq"};